import { graphql } from '#/lib/gql';
import { fetchGraphQL } from '#/lib/graphql';

const SUBSCRIBE_MUTATION = graphql(`
  mutation Subscribe($spaceId: String!, $email: String!) {
    member(spaceId: $spaceId) {
      subscribe(input: { email: $email })
    }
  }
`);

export async function subscribeToNewsletter(
  spaceId: string,
  email: string,
): Promise<void> {
  await fetchGraphQL(SUBSCRIBE_MUTATION, { spaceId, email });
}
